<div class="img-frame position-relative">
  @if (showLogo) {
    <div class="logo-placeholder">
      @if (currentItem?.imageIcon === null && currentRace?.imageMedium === null) {
        <img src="assets/img/bg3.jpg" alt="">
      } @else {
        <img src="{{ currentRace?.imageMedium ?? currentItem!.imageIcon}}" alt="" appImageFallback>
      }
    </div>
  }
  @if (showDateBadge) {
    <div class="date-wrapper">
        <span class="date-wrapper__month text-uppercase pr-4"
              [innerHTML]="currentRace && currentRace.raceStart ?
              formatDate(currentRace!.raceStart) :
              (currentItem && currentItem.start ? formatDate(currentItem!.start) : '')"
              ></span>
      <span [innerHTML]="currentRace && currentRace.raceStart ? (currentRace!.raceStart | date:'d') :
      (currentItem && currentItem.start ? (currentItem!.start | date:'d') : '')"></span>
      <span class="pr-4">,</span>
      <span [innerHTML]="currentRace && currentRace.raceStart ? (currentRace.raceStart | date:'yyyy')
        : (currentItem && currentItem.start ? (currentItem!.start | date:'yyyy') : '')"></span>
    </div>
  }
  <div class="img-frame__bg-div"
       [ngStyle]="{'background-image': getBackgroundImage()}" appImageFallback></div>
</div>
